export const defaultTheme = {
  colors: {
    neutral: {
      '0': '#ffffff',
      '50': '#f7f7f7',
      '100': '#f0f0f0',
      '200': '#e4e6e7',
      '300': '#c3c2c2',
      '400': '#999999',
      '500': '#787878',
      '600': '#555555',
      '700': '#444444',
      '800': '#303030',
      '900': '#181818',
      '1000': '#000000',
      '0-70': '#ffffffb3',
      '0-15': '#ffffff26',
      '0-30': '#ffffff33',
    },
    blue: {
      '100': '#e1eaf1',
      '300': '#90bafa',
      '500': '#0096ff',
      '600': '#0078cc',
      '700': '#005a99',
      '800': '#00385f',
      '900': '#26313c',
      '300-65': '#90bafaa6',
    },
    orange: {
      '50': '#fff5eb',
      '100': '#ffe9d9',
      '200': '#ffcea3',
      '300': '#ffb661',
      '400': '#ffa029',
      '500': '#fa8b00',
      '600': '#ef7a06',
      '650': '#b75b00',
      '700': '#964408',
      '800': '#682b08',
      '500-25': '#fa8b0040',
    },
    red: {
      '50': '#fff6f4',
      '100': '#fae3df',
      '300': '#ff9494',
      '500': '#ee0303',
      '600': '#c2311e',
      '650': '#b0293d',
      '500-30': '#e230304d',
    },
    green: {
      '100': '#eeffeb',
      '200': '#ccffc3',
      '300': '#3ed02b',
      '500': '#108a00',
      '600': '#0f8000',
      '800': '#105c26',
      '300-30': '#3ed02b4d',
    },
    slate: {
      '300': '#b4b9bd',
      '400': '#8a939a',
      '500': '#68737d',
      '600': '#4b555e',
      '700': '#2d3740',
      '900': '#212529',
      '900-5': '#2125290d',
      '900-10': '#2125291a',
      '900-50': '#21252980',
      '900-25': '#21252940',
      '900-15': '#21252926',
    },
    cream: {
      '100': '#dadbd3',
    },
    background: {
      base: '#ffffff',
      subtle: '#f7f7f7',
      component: {
        header: '#ffffff',
        footer: '#ffffff',
        input: {
          default: '#ffffff',
        },
        shared: {
          warning: '#fff5eb',
          disabled: '#f7f7f7',
          sale: '#b0293d',
          eco: '#105c26',
          'disabled-2': '#b4b9bd',
          success: '#eeffeb',
          focus: '#e1eaf1',
          error: '#fff6f4',
          brand: '#005a99',
        },
        button: {
          primary: {
            rest: '#00385f',
            hover: '#005a99',
            pressed: '#26313c',
            focused: '#00385f',
          },
          solid: {
            light: {
              hover: '#e4e6e7',
              focused: '#ffffff',
              rest: '#ffffff',
              pressed: '#b4b9bd',
            },
            dark: {
              rest: '#303030',
              hover: '#4b555e',
              focused: '#303030',
              pressed: '#212529',
            },
          },
          outline: {
            light: {
              hover: '#ffffff',
              pressed: '#b4b9bd',
            },
            dark: {
              hover: '#303030',
              pressed: '#4b555e',
            },
          },
        },
        glass: '#ffffffb3',
        'site-banner': '#ffffff',
        'input-elements': {
          default: '#ffffff',
          'active-default': '#212529',
          'active-pressed': '#212529',
          'active-hover': '#2d3740',
        },
        accordion: {
          rest: '#303030',
        },
        'carousel-arrow': {
          rest: '#303030',
          hover: '#4b555e',
          pressed: '#212529',
          focussed: '#303030',
        },
        'active-filter': {
          rest: '#f7f7f7',
          hover: '#e4e6e7',
        },
        'loading-1': '#e4e6e7',
      },
      inverse: '#212529',
      mid: '#68737d',
    },
    content: {
      primary: '#212529',
      secondary: '#4b555e',
      inverse: '#ffffff',
      error: '#c2311e',
      sale: '#108a00',
      'sale-alt': '#c2311e',
      tertiary: '#68737d',
      'brand-accent': '#00385f',
      hyperlink: '#212529',
      success: '#0f8000',
      warning: '#b75b00',
      component: {
        buttons: {
          success: {
            rest: '#00385f',
            hover: '#ffffff',
            color: {
              base: '#ffffff',
              hover: '#005a99',
            },
          },
          primary: {
            rest: '#303030',
            hover: '#ffffff',
            color: {
              base: '#ffffff',
              hover: '#212529',
            },
          },
          tertiary: {
            rest: '#303030',
            hover: '#303030',
            pressed: '#b4b9bd',
            color: {
              base: '#212529',
              hover: '#ffffff',
            },
          },
          transparent: {
            rest: '#ffffff',
            hover: '#ffffff',
            pressed: '#b4b9bd',
            color: {
              base: '#ffffff',
              hover: '#212529',
            },
          },
          disabled: {
            rest: '#E4E6E7',
            color: {
              base: '#8A939A',
            },
          },
          secondary: {
            rest: '#b4b9bd',
            hover: '#303030',
            color: {
              base: '#303030',
            },
          },
        },
        'dialog-close': {
          base: '#212529',
          color: '#ffffff',
        },
        header: {
          base: '#ffffff',
          color: '#212529',
          hover: '#4b555e',
          accessibility: '#999',
          highLight: '#303030',
          modal: {
            base: '#ffffff',
            color: '#212529',
          },
        },
        footer: {
          color: '#8A939A',
          hover: '#303030',
        },
        'close-button': '#8a939a',
        'dot-navigation-button': '#cccccc',
        'input-elements': {
          'active-hover': '#ffffff',
          'active-pressed': '#ffffff',
          'active-focussed': '#ffffff',
          'active-rest': '#ffffff',
          hover: '#f0f0f0',
          pressed: '#e4e6e7',
          focussed: '#e4e6e7',
        },
        disabled: '#68737d',
        placeholder: '#68737d',
        'loading-bar': '#b4b9bd',
        skeleton: '#b4b9bd',
        dark: '#212529',
        light: '#ffffff',
        accordion: {
          label: '#212529',
          icon: '#212529',
          content: '#4b555e',
        },
      },
      focus: '#005a99',
    },
    border: {
      success: '#0f8000',
      warning: '#ef7a06',
      base: '#212529',
      mid: '#8a939a',
      inverse: '#ffffff',
      focused: '#00385f',
      subtle: '#e4e6e7',
      component: {
        disabled: '#e4e6e7',
        'input-elements': {
          rest: '#4b555e',
          pressed: '#212529',
          'active-default': '#212529',
          'active-hover': '#4b555e',
          'active-pressed': '#212529',
          focussed: '#0078cc',
          hover: '#2d3740',
        },
        shared: {
          focus: '#0078cc',
        },
        accordion: {
          separator: '#e4e6e7',
        },
        button: {
          dark: '#212529',
          light: '#ffffff',
        },
        select: {
          light: '#dcdcdc',
        },
      },
      error: '#ee0303',
    },
    effect: {
      'shadow-10': '#2125291a',
      'shadow-5': '#2125290d',
      component: {
        hover: '#21252926',
        pressed: '#21252940',
      },
      focus: '#0078cc',
      error: '#e230304d',
      success: '#3ed02b4d',
    },
  },
  font: {
    weight: {
      regular: 'Book',
      bold: 'Bold',
      black: 'Black',
      ultra: 'Ultra',
      medium: 'Medium',
    },
    family: {
      primary: 'Gotham HCo',
      secondary: 'Acumin Pro Condensed',
    },
    size: {
      '1': '10px',
      '2': '12px',
      '3': '14px',
      '4': '16px',
      '5': '18px',
      '6': '20px',
      '7': '24px',
      '8': '32px',
      '9': '48px',
      '10': '56px',
      '11': '64px',
      '12': '72px',
      '13': '96px',
    },
  },
  size: {
    '0': '0px',
    '1': '4px',
    '2': '8px',
    '3': '12px',
    '4': '16px',
    '5': '20px',
    '6': '24px',
    '8': '32px',
    '10': '40px',
    '12': '48px',
    '16': '64px',
    '20': '80px',
    '30': '120px',
    '250': '1000px',
    '0-25': '1px',
    '0-5': '2px',
    '0-75': '3px',
    component: {
      'close-button': '10px',
    },
  },
  padding: {
    '2xs': '8px',
    xs: '12px',
    sm: '16px',
    md: '24px',
    lg: '40px',
    xl: '64px',
    '2xl': '80px',
    none: '0px',
    '3xs': '4px',
    '4xs': '2px',
  },
  borders: {
    width: {
      '0': '0px',
      xs: '1px',
      sm: '2px',
      md: '3px',
    },
    radius: {
      '0': '0px',
      circular: '1000px',
      xs: '1px',
    },
  },
  typography: {
    mobile: {
      heading: {
        md: '24px',
        lg: '32px',
        xl: '48px',
        '2xl': '56px',
        sm: '20px',
        xs: '16px',
      },
      body: {
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        xs: '12px',
        '2xs': '10px',
        '2xl': '24px',
      },
    },
    tablet: {
      heading: {
        md: '24px',
        lg: '32px',
        xl: '56px',
        '2xl': '64px',
        sm: '20px',
        xs: '16px',
      },
      body: {
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        xs: '12px',
        '2xs': '10px',
        '2xl': '24px',
      },
    },
    desktop_sm: {
      heading: {
        md: '32px',
        lg: '48px',
        xl: '64px',
        '2xl': '72px',
        sm: '24px',
        xs: '16px',
      },
      body: {
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        xs: '12px',
        '2xs': '10px',
        '2xl': '24px',
      },
    },
    desktop_lg: {
      heading: {
        md: '32px',
        lg: '56px',
        xl: '72px',
        '2xl': '96px',
        sm: '24px',
        xs: '16px',
      },
      body: {
        sm: '16px',
        md: '18px',
        lg: '20px',
        xl: '24px',
        xs: '12px',
        '2xs': '10px',
        '2xl': '32px',
      },
    },
  },
  spacing: {
    y: {
      '2xs': '4px',
      xs: '8px',
      md: '16px',
      lg: '24px',
      xl: '40px',
      '3xl': '80px',
      '4xl': '120px',
      sm: '12px',
      '2xl': '64px',
    },
    x: {
      '2xs': '4px',
      xs: '8px',
      md: '16px',
      lg: '24px',
      xl: '40px',
      '3xl': '80px',
      '4xl': '120px',
      sm: '12px',
      '2xl': '64px',
    },
  },
};
